import { createSelector } from 'reselect';

export const getTermsSection = state => state.getIn(['cms', 'terms']);
export const getResponsibleGamblingSection = state => state.getIn(['cms', 'responsibleGambling']);
export const getPrivacySection = state => state.getIn(['cms', 'privacy']);
export const getSupportSections = state => state.getIn(['cms', 'support']);
export const getLoginOnlineTerms = state => state.getIn(['cms', 'loginOnlineTerms']);
export const getRegisterOnlineTerms = state => state.getIn(['cms', 'registerOnlineTerms']);
export const getSliders = state => state.getIn(['cms', 'homepageSliders']);
export const getHomepageSliderDuration = createSelector(
  getSliders,
  sliders => sliders.size && sliders.getIn([0, 'durationTime'])
);
